class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.addEventListener('click', (evt) => {
      if (evt.target && (evt.target.id === 'CartDrawer-Overlay' || evt.target.classList.contains('cart-drawer__overlay'))) {
        this.close();
      }
    });
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      if (window.ssHeaderUI && typeof window.ssHeaderUI.closeAll === 'function') {
        window.ssHeaderUI.closeAll({ cart: true });
      }
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => { this.classList.add('animate', 'active'); });

    const trap = () => {
      if (this._ssTrapped) return;
      this._ssTrapped = true;
      const containerToTrapFocusOn = this.querySelector('.drawer__inner');
      const focusElement = this.querySelector('.ss-cd__close, .drawer__close') || containerToTrapFocusOn;
      if (containerToTrapFocusOn) trapFocus(containerToTrapFocusOn, focusElement);
    };
    this.addEventListener('transitionend', trap, { once: true });
    setTimeout(trap, 320);

    document.body.classList.add('overflow-hidden');
    if (typeof window.ssSyncScrollLock === 'function') window.ssSyncScrollLock();
  }

  close() {
    this.classList.remove('active');
    this._ssTrapped = false;
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    if (typeof window.ssSyncScrollLock === 'function') window.ssSyncScrollLock();
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling && cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    const inner = this.querySelector('.drawer__inner');
    if (inner && inner.classList.contains('is-empty')) inner.classList.remove('is-empty');
    this.classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const html = parsedState.sections && parsedState.sections[section.id];
      if (!html) return;

      /* Custom header: never replace the cart icon mark-up — badge only */
      if (section.id === 'cart-icon-bubble') {
        this.updateCartBadge(html);
        return;
      }

      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      if (!sectionElement) return;
      const nextHtml = this.getSectionInnerHTML(html, section.selector);
      if (nextHtml != null) sectionElement.innerHTML = nextHtml;
    });

    setTimeout(() => {
      const overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', this.close.bind(this));
      if (window.ssHeaderUI && typeof window.ssHeaderUI.closeAll === 'function') {
        window.ssHeaderUI.closeAll({ cart: true });
      }
      this.open();
    });
  }

  updateCartBadge(sectionHtml) {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    const countEl =
      doc.querySelector('.cart-count-bubble [aria-hidden="true"]') ||
      doc.querySelector('.cart-count-bubble span[aria-hidden]');
    const countText = countEl ? countEl.textContent.trim() : '';
    const count = parseInt(countText, 10);
    let badge = cartLink.querySelector('.ss-badge, .cart-count-bubble');
    if (!isNaN(count) && count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'ss-badge cart-count-bubble';
        cartLink.appendChild(badge);
      }
      badge.innerHTML = '<span aria-hidden="true">' + count + '</span>';
    } else if (badge) {
      badge.remove();
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const node = selector ? doc.querySelector(selector) : null;
    if (node) return node.innerHTML;
    const section = doc.querySelector('.shopify-section');
    if (section) return section.innerHTML;
    return doc.body ? doc.body.innerHTML : html;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    const cart = document.querySelector('cart-drawer');
    const empty = cart && cart.classList.contains('is-empty');
    if (empty) {
      return [
        {
          id: 'CartDrawer',
          section: 'cart-drawer',
          selector: '.drawer__inner'
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section'
        }
      ];
    }
    return [
      {
        id: 'CartDrawer-CartItems',
        section: 'cart-drawer',
        selector: '#CartDrawer-CartItems'
      },
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.ss-cd__footer'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
